import { render } from "./NewBrand.vue?vue&type=template&id=20e18845"
import script from "./NewBrand.vue?vue&type=script&lang=js"
export * from "./NewBrand.vue?vue&type=script&lang=js"

import "./NewBrand.vue?vue&type=style&index=0&id=20e18845&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__